/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Одна команда, выданная клиенту с lease-токеном
 * @export
 * @interface FxIdWebFeaturesClientCommandsClaimClaimedCommand
 */
export interface FxIdWebFeaturesClientCommandsClaimClaimedCommand {
    /**
     * Первичный ключ команды
     * @type {number}
     * @memberof FxIdWebFeaturesClientCommandsClaimClaimedCommand
     */
    Id: number;
    /**
     * Тип команды (например "registration_gtag_event")
     * @type {string}
     * @memberof FxIdWebFeaturesClientCommandsClaimClaimedCommand
     */
    CommandType: string;
    /**
     * Данные команды, десериализованные из JSON
     * @type {any}
     * @memberof FxIdWebFeaturesClientCommandsClaimClaimedCommand
     */
    CommandData?: any | null;
    /**
     * Режим доставки ("reliable" и т.д.)
     * @type {string}
     * @memberof FxIdWebFeaturesClientCommandsClaimClaimedCommand
     */
    DeliveryMode: string;
    /**
     * Lease-токен для последующего подтверждения (ack)
     * @type {string}
     * @memberof FxIdWebFeaturesClientCommandsClaimClaimedCommand
     */
    LeaseToken: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesClientCommandsClaimClaimedCommand interface.
 */
export function instanceOfFxIdWebFeaturesClientCommandsClaimClaimedCommand(value: object): value is FxIdWebFeaturesClientCommandsClaimClaimedCommand {
    if (!('Id' in value) || value['Id'] === undefined) return false;
    if (!('CommandType' in value) || value['CommandType'] === undefined) return false;
    if (!('DeliveryMode' in value) || value['DeliveryMode'] === undefined) return false;
    if (!('LeaseToken' in value) || value['LeaseToken'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesClientCommandsClaimClaimedCommandFromJSON(json: any): FxIdWebFeaturesClientCommandsClaimClaimedCommand {
    return FxIdWebFeaturesClientCommandsClaimClaimedCommandFromJSONTyped(json, false);
}

export function FxIdWebFeaturesClientCommandsClaimClaimedCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesClientCommandsClaimClaimedCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'Id': json['Id'],
        'CommandType': json['CommandType'],
        'CommandData': json['CommandData'] == null ? undefined : json['CommandData'],
        'DeliveryMode': json['DeliveryMode'],
        'LeaseToken': json['LeaseToken'],
    };
}

export function FxIdWebFeaturesClientCommandsClaimClaimedCommandToJSON(json: any): FxIdWebFeaturesClientCommandsClaimClaimedCommand {
    return FxIdWebFeaturesClientCommandsClaimClaimedCommandToJSONTyped(json, false);
}

export function FxIdWebFeaturesClientCommandsClaimClaimedCommandToJSONTyped(value?: FxIdWebFeaturesClientCommandsClaimClaimedCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Id': value['Id'],
        'CommandType': value['CommandType'],
        'CommandData': value['CommandData'],
        'DeliveryMode': value['DeliveryMode'],
        'LeaseToken': value['LeaseToken'],
    };
}

